import { useParams } from 'react-router';
import { useTranslation } from 'react-i18next';

import { LoadingFailedBox, NgBreadcrumbItem, NgBreadcrumbs, NgPageHeader } from '@/ui';
import { incidentDetailRoute } from '@/features/shared/routes';
import { useIncidentLiveVideos } from '@ngsos/portal-core/video';
import { VideoRecordingListComponent } from './VideoRecordingListComponent';
import { VideoRecordingListLoadingPlaceholder } from './VideoRecordingListLoadingPlaceholder';

export function RecordingListPage() {
  const { t } = useTranslation();
  const { incidentId = '' } = useParams<{ incidentId: string }>();

  const pageTitle = t('PageTitle_ListOfRecordings');

  const { liveVideos, isLoading, unavailable: showError, retry } = useIncidentLiveVideos(incidentId);

  return (
    <div className="content p-3">
      <NgBreadcrumbs>
        <NgBreadcrumbItem title={t('PageTitle_Incident')} to={incidentDetailRoute(incidentId)} />
      </NgBreadcrumbs>

      <NgPageHeader title={pageTitle} />
      <h1>{pageTitle}</h1>

      {isLoading ? (
        <VideoRecordingListLoadingPlaceholder />
      ) : showError ? (
        <LoadingFailedBox onRetry={retry} />
      ) : (
        <VideoRecordingListComponent incidentId={incidentId} liveVideos={liveVideos} />
      )}
    </div>
  );
}
